import React from 'react';
import SharedSectionNav from '../../shared/SectionNav';
import { useContentMount } from '../contentMount';
import { editSections, programEditPath } from './editSections';

interface SectionNavProps {
  programId: number;
}

const SectionNav = ({ programId }: SectionNavProps) => {
  const mount = useContentMount();
  const sections = editSections.map(section => ({
    index: section.path === '',
    label: section.label,
    to: section.path === undefined ? undefined : programEditPath(programId, mount, section.path),
  }));

  return <SharedSectionNav label="Program settings sections" sections={sections} />;
};

export default SectionNav;
